import React from 'react';

const SelectComponent = ({ label, value, options, onChange, required }) => {
  const handleChange = (e) => onChange(e.target.value);
  const isEmpty = value === '' || value === null || value === undefined;

  return (
    <>
      <label className="form-label">
        {label}
        {required && <span className="req">*</span>}
      </label>
      <select
        className={`form-select${isEmpty ? ' is-placeholder' : ''}`}
        value={value ?? ''}
        onChange={handleChange}
        required={required}
      >
        <option value="" disabled>Select {label}…</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
};

export default SelectComponent;
